import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllPlans, deletePlan } from "../../redux/slices/planSlice";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const PlansList = () => {

  const dispatch = useDispatch();
  const { plans, loading } = useSelector((state) => state.plan);

  useEffect(() => {
    dispatch(getAllPlans());
  }, [dispatch]);

  // 🗑️ Delete handler
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await dispatch(deletePlan(id)).unwrap();

          Swal.fire(
            "Deleted!",
            "Plan has been deleted.",
            "success"
          );

        } catch (err) {
          Swal.fire("Error", err.message || "Delete failed", "error");
        }
      }
    });
  };


  return (

    <div className="container mt-4">

      <div className="card shadow-lg border-0">

        {/* Header */}
        <div className="card-header d-flex justify-content-between align-items-center bg-dark text-white">
          <h4 className="mb-0 text-white">Plans List</h4>

          <Link to="/create-plan" className="btn btn-success">
            ➕ Create Plan
          </Link>
        </div>

        {/* Body */}
        <div className="card-body">

          {loading ? (
            <p>Loading...</p>
          ) : (

            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle">

                <thead className="table-dark">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Price (₹)</th>
                    <th>Listings</th>
                    <th>Leads</th>
                    <th>Duration</th>
                    <th>Badge</th>
                    <th>Features</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {plans.length > 0 ? (
                    plans.map((plan, index) => (
                      <tr key={plan._id}>

                        <td>{index + 1}</td>

                        <td>
                          <strong>{plan.name}</strong>
                        </td>

                        <td>₹{plan.price}</td>

                        <td>{plan.maxListings}</td>

                        <td>{plan.maxLeads}</td>

                        <td>
                          {plan.durationDays === 0
                            ? "Unlimited"
                            : `${plan.durationDays} Days`}
                        </td>

                        <td>{plan.verifiedBadge}</td>

                        <td>
                          <ul className="mb-0 ps-3">
                            {plan.features?.map((f, i) => (
                              <li key={i}>{f}</li>
                            ))}
                          </ul>
                        </td>

                        <td>
                          <div className="d-flex gap-2">

                            {/* ✏️ Edit */}
                            <Link
                              to={`/edit-plan/${plan._id}`}
                              className="btn btn-sm btn-primary"
                            >
                              ✏️
                            </Link>

                            {/* 🗑️ Delete */}
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => handleDelete(plan._id)}
                            >
                              🗑️
                            </button>

                          </div>
                        </td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No Plans Found
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>

          )}

        </div>
      </div>
    </div>
  );
};

export default PlansList;